module.exports = __webpack_public_path__ + "img/banner-profile-shadow.464e944a.png";